import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ViewChild, Renderer2 } from '@angular/core';
import { ViewChildren, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { take, takeUntil, tap } from 'rxjs/operators';
import { UtilsService } from '../../../services/utils/utils.service';
import { ValidationDiscountService } from '../../../../core/providers/services/validation-discount/validation-discount.service';
import { AmbitosPaisesService } from '../../../../core/providers/services/ambitos-paises/ambitos-paises.service';
import { SelectMultipleValueModel } from '../../../../core/models/select-multiple.model';
import { CotizarService } from '../../../../core/providers/services/cotizar/cotizar.service';
import { SobreprimasService } from '../../../../core/providers/services/sobreprimas/sobreprimas.service';
import { DocumentsService } from '../../../../../app/core/providers/services/documents/documents.service';
import { CommonService } from '../../../../../app/core/providers/forms/common.service';
import { InputModel } from '../../../../../app/core/models/input.model';
import StudentsStepOne from './students-step-one.utils';
import { Numbers } from 'src/app/utils/constants';
import StudentsStepOneExtended from './students-step-one.utils-extended';
import { ProductIdCorreduria } from 'src/app/core/interfaces/producto-informacion.interface';

@Component({
  selector: 'app-students-step-one',
  templateUrl: './students-step-one.component.html',
  styleUrls: ['./students-step-one.component.scss']
})

export class StudentsStepOneComponent implements OnInit, OnDestroy, AfterContentChecked {
  /**
   * Constructor
   * @param fb fb
   * @param vdSrv vdSrv
   * @param apSrv apSrv
   * @param cotSrv cotSrv
   * @param utilsSrv utilsSrv
   * @param sobreprimasSrv sobreprimasSrv
   * @param commons commons
   * @param document document
   * @param gtmService gtmService
   * @param changeDetector changeDetector
   */
  constructor(
    private fb: FormBuilder,
    private vdSrv: ValidationDiscountService,
    private apSrv: AmbitosPaisesService,
    readonly cotSrv: CotizarService,
    private utilsSrv: UtilsService,
    private sobreprimasSrv: SobreprimasService,
    private readonly commons: CommonService,
    private readonly document: DocumentsService,
    readonly gtmService: GoogleTagManagerService,
    private changeDetector: ChangeDetectorRef,
    private readonly renderer: Renderer2
  ) {
    this.fb = fb;
    this.vdSrv = vdSrv;
    this.apSrv = apSrv;
    this.cotSrv = cotSrv;
    this.utilsSrv = utilsSrv;
    this.sobreprimasSrv = sobreprimasSrv;
    this.commons = commons;
    this.document = document;
    this.gtmService = gtmService;
    this.changeDetector = changeDetector;
    this.renderer = renderer;
    this.utils = new StudentsStepOne(this.gtmService, this.commons, this.utilsSrv, this.cotSrv, this.renderer);
    this.utilsExtended = new StudentsStepOneExtended();
  }

  @Input() formData: FormGroup;
  @Input() formConfig: any;
  @Input() clickBtnPos: string;
  @Input() productosCorreduria: ProductIdCorreduria[] = [];
  @Output() clickBtn: EventEmitter<'back' | 'next'> = new EventEmitter();
  @ViewChild('chips', { static: false }) chips: any;
  @ViewChildren('select') selecter: any;

  public utils: StudentsStepOne;
  public utilsExtended: StudentsStepOneExtended;

  /**
   * ngOnInit
   */
  ngOnInit() {
    localStorage.removeItem('layer1');
    localStorage.removeItem('layer2');
    localStorage.removeItem('budget');
    localStorage.removeItem('email');
    localStorage.removeItem('ndc');
    localStorage.removeItem('stepThanks');
    localStorage.removeItem('pay');
    localStorage.removeItem('resetForm');
    let isPrevious = false;
    if (localStorage.getItem('prev-step1') !== null) {
      isPrevious = true;
    }
    if (!isPrevious) {
      localStorage.removeItem('s1Duration');
      // localStorage.removeItem('radio-card');
      sessionStorage.removeItem('radio-card');
    }
    this.utils.loadVars(this.formConfig.currentStep.value, this.formConfig.numberOfInsured.linkFormPath[0],
      this.formConfig.numberOfInsured, this.formConfig.insuredOlderThan60years,
      this.formConfig.allInsuredSameFamiliarUnit.checked);
    this.formData.get([this.utils.insureSelected, 'numberOfInsuredList']);
    this.formData.get([this.utils.insureSelected, 'numberOfInsuredList']).setValue(this.utils.numberOfInsuredList.options.list);
    if (this.formData.get([this.utils.insureSelected, 'countryOrigin']).value.name === undefined) {
      this.formData.get([this.utils.insureSelected, 'countryOrigin']).setValue({ name: 'España', id: Numbers.number19001 });
      this.getEnvironmentCountry(this.formData.get([this.utils.insureSelected, 'countryOrigin']).value,
        [this.utils.insureSelected, 'countryOriginEnvironment']);
    }
    const auxDurationValue: any = this.formData.get([this.utils.insureSelected, 'insuranceDuration']).value;
    if (isPrevious) {
      this.utils.insuranceTime = auxDurationValue;
      if (auxDurationValue.indexOf('form1') > -1) {
        this.utils.insuranceTime = this.utilsSrv.getTranslate(auxDurationValue);
      }
      localStorage.removeItem('prev-step1');
      this.utils.showStep1Fields = true;
      this.utils.isOrigenSpain = true;
      if (this.formData.get([this.utils.insureSelected, 'typeStudent']).value === 'Incoming') {
        this.utils.isOrigenSpain = false;
      }
      if (this.formData.get([this.utils.insureSelected, 'countryOrigin']).value.id !== undefined &&
          this.formData.get([this.utils.insureSelected, 'countryOrigin']).value.id === Numbers.number19001
         && this.formData.get([this.utils.insureSelected, 'countryDestiny']).value.id !== undefined &&
         this.formData.get([this.utils.insureSelected, 'countryDestiny']).value.id === Numbers.number67) {
        this.utils.isOriginDestinySpain = true;
      } else {
        this.utils.isOriginDestinySpain = false;
      }
    }
    if (auxDurationValue !== '') {
      this.utils.formDataValue = this.formData.get(this.utils.insureSelected).value;
      this.utils.isInvalid = true;
      if (this.formData.get(this.utils.insureSelected).valid) {
        this.utils.isInvalid = false;
      }
    }
    if (this.formData.get([this.utils.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value !== '') {
      this.utils.showGuaranteeTable = true;
      this.utils.idProduct = this.formData.get([this.utils.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.idProducto;
    }
    this.formData.get([this.utils.insureSelected, 'insuranceDuration']).setValue('Temporal');
    this.formData.get([this.utils.insureSelected, 'insuredsPlayRiskSports']).setValue({id: 0});
    this.utils.getLisIniGuaranteeLimitOfMedicalExpensesUtils(this.formConfig, this.formData);
    // Recuperamos la lista de garantias
    this.utils.setValidatorUtils(this.formData);
    this.initObs();
  }

  /**
   * ngAfterContentChecked
   */
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    this.utils.finish.next(true);
  }

  /**
   * initObs
   */
  initObs(): void {
    this.formData.get(this.utils.insureSelected).valueChanges.pipe(takeUntil(this.utils.finish),
    tap(() => {
          this.utils.initObsUtils(this.formData);
        })
      ).subscribe();
    this.getCountryOrigin();
    this.getCountryDestinyFormData();
    this.getCountryDestinyFormDataI();
    this.getNumberOfInsured();
    this.getGuaranteeLimitOfMedicalExpenses();
    this.getInsuredOlderThan60years();
    this.getCurrentlyTraveling();
    this.getDateStart();
    this.getDateEnd();
    this.getAllInsuredSameFamiliarUnit();
    this.getHasCodeDerogation();
  }

  /**
   * getNumberOfInsured
   */
  getNumberOfInsured(): void {
    this.formData.get([this.utils.insureSelected, 'numberOfInsured']).valueChanges.pipe(takeUntil(this.utils.finish),
    tap((num) => {
      this.utils.numberOfInsuredChange = true;
      this.utils.numberOfInsuredMax = num.id;
      this.utils.reloadNumber70Utils(this.formData, 0, num.id);
      const formArr = this.formData.get([this.utils.insureSelected, 'insuredListData']) as FormArray;
      formArr.clear();
      for (let index = 0; index < +num.id; index++) {
        formArr.push(
          this.fb.group({
            documentType: '',
            documentNumber: '',
            name: '',
            firstSurname: '',
            secondSurname: '',
            dateBorn: '',
            email: '',
            prima: 0,
            msgLoading: ''
          })
        );
      }
      })
    ).subscribe();
  }

  /**
   * getGuaranteeLimitOfMedicalExpenses
   */
  getGuaranteeLimitOfMedicalExpenses(): void {
    this.formData.get([this.utils.insureSelected, 'guaranteeLimitOfMedicalExpenses']).valueChanges.pipe(takeUntil(this.utils.finish),
    tap((el) => {
          this.utils.idProduct = el.idProducto;
          this.formData.get([this.utils.insureSelected, 'guaranteeSelectionList']).setValue('');
          this.utils.resetTableUtils(this.formData);
          this.utilsExtended.checkShowGuaranteeTableUtils(this.formData, this.utils.insureSelected);
          this.getSobreprimas();
          this.utils.resetGuaranteeSelectionUtils(this.formData);
        })
      ).subscribe();
  }

  /**
   * getInsuredOlderThan60years
   */
  getInsuredOlderThan60years(): void {
    this.formData.get([this.utils.insureSelected, 'insuredOlderThan60years']).valueChanges.pipe(takeUntil(this.utils.finish),
        tap((el) => {
          this.utils.validNumberOfInsuredUtils(this.formData);
        })
      ).subscribe();
  }

  /**
   * getCountryDestinyFormData
   */
  getCountryDestinyFormData(): void {
    this.formData.get([this.utils.insureSelected, 'countryDestiny']).valueChanges.pipe(takeUntil(this.utils.finish),
      tap((country: SelectMultipleValueModel) => {
        this.utils.changeCountry(country, this.formConfig, this.formData);
        // Actualizamos la lista de garantias
        if (this.utils.isFieldO) {
          this.getEnvironmentCountry(country, [this.utils.insureSelected, 'countryDestinyEnvironment']);
          if (this.formData.get([this.utils.insureSelected, 'countryDestiny']).value.length === 0) {
            this.utils.isFieldO = true;
          } else {
            this.utils.isFieldO = false;
          }
        }
      })
    ).subscribe();
  }

  /**
   * getCountryDestinyFormDataI
   */
  getCountryDestinyFormDataI(): void {
    this.formData.get([this.utils.insureSelected, 'countryDestinyI']).valueChanges.pipe(takeUntil(this.utils.finish),
    tap((country: InputModel) => {
          // reseteamos la lista de ambitos de paises
      if (country !== undefined && this.utilsExtended.isFieldI) {
            this.formData.get([this.utils.insureSelected, 'countryDestinyEnvironment']).setValue(Numbers.number19001);
            this.utilsExtended.countryDestiny(this.formData.get([this.utils.insureSelected, 'countryDestinyI']).value);
            this.utils.showStepFields(this.formData);
          }
        })
      ).subscribe();
  }

  /**
   * getCountryOrigin
   */
  getCountryOrigin(): void {
    this.formData.get([this.utils.insureSelected, 'countryOrigin']).valueChanges.pipe(takeUntil(this.utils.finish),
    tap((country: SelectMultipleValueModel) => {
          this.utils.countryChange = { name: 'countryRisk', value: country }; // reseteamos la lista de ambitos de paises
          this.utils.isOrigenSpain = false;
          this.utils.disabledDestiny = true;
          this.utils.disabledDestinySpain = true;
          this.utils.isFieldO = false;
          this.utilsExtended.isFieldI = true;
          this.formData.get([this.utils.insureSelected, 'countryDestiny']).setValue('');
          if (country.name === 'España') {
            this.utils.isOrigenSpain = true;
            this.utils.disabledDestiny = false;
            this.utils.disabledDestinySpain = false;
            this.utils.isFieldO = true;
            this.utilsExtended.isFieldI = false;
            this.formData.get([this.utils.insureSelected, 'countryDestinyI']).setValue('');
            this.formData.get([this.utils.insureSelected, 'countryDestiny']).setValue('');
          }
          this.utils.getLisIniGuaranteeLimitOfMedicalExpensesUtils(this.formConfig, this.formData);
          // Actualizamos la lista de garantias
          this.formData.get([this.utils.insureSelected, 'countryOriginEnvironment']).setValue('');
          if (country.name === 'España') {
            this.formData.get([this.utils.insureSelected, 'countryDestinyEnvironment']).setValue('');
          }
          this.getEnvironmentCountry(country, [this.utils.insureSelected, 'countryOriginEnvironment']);
          if (!this.utils.isOrigenSpain) {
            this.utils.destinySpain = { name: 'destiny', value: 'España' };
          } else {
            this.formData.get([this.utils.insureSelected, 'countryDestiny']).setValue('');
          }
        })
      ).subscribe();
  }

  /**
   * getCurrentlyTraveling
   */
  getCurrentlyTraveling(): void {
    this.formData.get([this.utils.insureSelected, 'currentlyTraveling']).valueChanges.pipe(takeUntil(this.utils.finish),
        tap((el) => {
          this.utils.getDateUtils(this.formData);
        })
      ).subscribe();
  }

  /**
   * getDateStart
   */
  getDateStart(): void {
    this.formData.get([this.utils.insureSelected, 'dateStart']).valueChanges
    .pipe(takeUntil(this.utils.finish), tap((el) => {
        this.utils.getDateUtils(this.formData);
        })
      ).subscribe();
  }

  /**
   * getDateEnd
   */
  getDateEnd(): void {
    this.formData.get([this.utils.insureSelected, 'dateEnd']).valueChanges
    .pipe(takeUntil(this.utils.finish), tap((el) => {
        this.utils.getDateUtils(this.formData);
        })
      ).subscribe();
  }

  /**
   * getAllInsuredSameFamiliarUnit
   */
  getAllInsuredSameFamiliarUnit(): void {
    this.formData.get([this.utils.insureSelected, 'allInsuredSameFamiliarUnit']).valueChanges
    .pipe(takeUntil(this.utils.finish), tap(() => {
          if (this.formData.get([this.utils.insureSelected, 'allInsuredSameFamiliarUnit']).value) {
            this.utils.reloadNumberOfInsurablesUtils(this.formData, this.formConfig, Numbers.number2, Numbers.number10);
          } else {
            this.utils.reloadNumberOfInsurablesUtils(this.formData, this.formConfig);
          }
        })
      ).subscribe();
  }

  /**
   * getHasCodeDerogation
   */
  getHasCodeDerogation(): void {
    this.formData.get([this.utils.insureSelected, 'hasCodeDerogation']).valueChanges
    .pipe(takeUntil(this.utils.finish), tap(() => {
      this.utils.getHasCodeDerogationUtils(this.formConfig, this.formData);
        })
      ).subscribe();
  }

  /**
   * getSobreprimas
   */
  getSobreprimas(): void {
    this.sobreprimasSrv.getSobreprimaList(
        this.formData.get([this.utils.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value)
    .pipe(take(1)).subscribe((sobreprimas: any) => {
        this.utils.sobreprimasList = sobreprimas; // Consigue el array de sobreprimas
        if (this.formData.get([this.utils.insureSelected, 'allInsuredSameFamiliarUnit']).value) {
          this.utils.reloadNumberOfInsurablesUtils(this.formData, this.formConfig, Numbers.number2, Numbers.number10);
        } else {
          this.utils.reloadNumberOfInsurablesUtils(this.formData, this.formConfig);
        }

      });
  }

  /**
   * checkCodePromotional
   * @param code code
   */
  checkCodePromotional(code: string): void {
    this.vdSrv.getCheckValidationCode(code).pipe(take(1)).subscribe((codeStatus: any) => {
        if (!codeStatus) {
          this.utils.promotionChange = { name: 'promo', value: 'error' };
        }
      });
  }

  /**
   * checkCodePromotional2
   * @param code code
   */
  checkCodePromotional2(code: string): void {
    this.vdSrv.getCheckValidationCode(code).pipe(take(1)).subscribe((codeStatus: any) => {
        if (!codeStatus) {
          this.utils.promotionChange = { name: 'promo', value: 'error' };
        }
        this.utils.checkPromoS = codeStatus;
      });
    setTimeout(() => {
      return this.utils.checkPromoS;
    }, Numbers.number200);
  }

  /**
   * dataEmit
   * @param ev ev
   */
  dataEmit(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) {
        keyPress = ev;
      }
      if (keyPress && keyPress !== null && keyPress.enter) {
        this.checkCodePromotional(this.formData.get(this.formConfig.codePromotional.linkFormPath).value);
      }
    }
  }

  /**
   * getGreaterScope
   * @param listA listA
   * @param path path
   */
  getGreaterScope(listA: any, path: any): void {
    setTimeout(() => {
      this.setCountryEnvironments(this.utilsExtended.getGreaterScopeUtils(0, listA), path);
    }, Numbers.number200);
  }

  /**
   * getEnvironmentCountry
   * @param listCountry listCountry
   * @param path path
   */
  getEnvironmentCountry(listCountry: any, path: any): void {
    // Llamamos para recuperar cada codigo de ambito de pais
    if (listCountry !== undefined && typeof listCountry !== 'string' && listCountry.length > 0) {
      const listA: any[] = [];
      listCountry.forEach((country: SelectMultipleValueModel) => {
        let nameC: any = country;
        if (country.name !== undefined) {
          nameC = country.name;
        }
        this.apSrv.getEnvironmentCountry(nameC).pipe(take(1)).subscribe((countryEnvironmentCode: any) => {
            listA.push(parseInt(countryEnvironmentCode, Numbers.number10));
            this.getGreaterScope(listA, path);
          });
      });
    } else {
      let nameC = '';
      if (listCountry) {
        nameC = listCountry;
        if (listCountry.name) {
          nameC = listCountry.name;
        }
      }
      if (Object.keys(nameC).length > 0) {
        this.apSrv.getEnvironmentCountry(nameC).pipe(take(1)).subscribe((countryEnvironmentCode) => {
            this.setCountryEnvironments(countryEnvironmentCode, path);
          });
      }
    }
  }

  /**
   * setCountryEnvironments
   * @param setCountryEnvironment setCountryEnvironment
   * @param path path
   */
  setCountryEnvironments(setCountryEnvironment: any, path: string): void {
    this.formData.get(path).setValue(setCountryEnvironment);
    this.utils.showStepFields(this.formData);
  }

  /**
   * clickButton
   * @param ev ev
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (this.formData.get([this.utils.insureSelected, 'codePromotional']).value !== '') {
      this.checkCodePromotional2(this.formData.get([this.utils.insureSelected, 'codePromotional']).value);
      setTimeout(() => {
        if (this.utils.checkPromoS) {
          this.prepareAndEmitev(ev);
        }
      }, Numbers.number350);
    } else {
      this.prepareAndEmitev(ev);
    }
  }

  /**
   * prepareAndEmitev
   * @param ev ev
   */
  prepareAndEmitev(ev: any): void {
    this.utils.callCotizar(this.utils.formDataValue, this.formConfig, this.utils.isOriginDestinySpain,
      this.utils.isOrigenSpain, this.productosCorreduria);
    this.utils.datalayer(this.formData.get('insureSelected').value);
    this.clickBtn.emit(ev);
  }

  /**
   * hasDerogationCode
   * @returns returns
   */
  hasDerogationCode(): void {
    return this.formData.get([this.utils.insureSelected, 'hasCodeDerogation']).value;
  }

  /**
   * Updates the country destiny field in the form
   */
  destinyUpdater(): void {
    this.utils.isFieldO = true;
    this.formData.get([this.utils.insureSelected, 'countryDestiny']).
    setValue(this.formData.get([this.utils.insureSelected, 'countryDestiny']).value);
  }
}
